import { render, staticRenderFns } from "./TermsAndConditionsComponent.vue?vue&type=template&id=6b8b072b&scoped=true&"
import script from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsComponent.vue?vue&type=style&index=0&id=6b8b072b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b072b",
  null
  
)

export default component.exports